<template>
    <div>
        <NavBar />
        <div class="administration-page">
            <div class="menu">
                <h1>
                    <span>Catégories</span>
                    <span class="material-symbols-outlined" @click="toggleCategoryModale">add_circle</span>
                </h1>

                <ul>
                    <li v-for="category in categories_list" :key="category._id">
                        <router-link :to="'/academy-admin/category/' + category._id">{{ category.name }}</router-link>
                    </li>
                </ul>

                <h1>
                    <router-link to="/academy-admin/quiz-model/">Questionnaires</router-link>
                </h1>

                <h1>
                    <router-link to="/academy-admin/evaluations/">Évaluations en cours</router-link>
                </h1>
            </div>

            <modale :show="showCategoryCreation" @toggle="toggleCategoryModale">
                <div class="form-section">
                    <label>Nom de la catégorie</label>
                    <input type="text" v-model="newCategoryLabel">
                </div>

                <div class="btn-wrapper">
                    <div class="save-btn" @click="createCategory">Enregistrer</div>
                </div>
            </modale>

            <div class="content-wrapper">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            categories_list: [],
            showCategoryCreation: false,
            newCategoryLabel: "",
        }
    },
    methods: {
        toggleCategoryModale() {
            this.showCategoryCreation = !this.showCategoryCreation;
        },
        async loadCategories() {
            const result = await axios.get(this.$store.getters.get_api_url + 'academy/categories');
            this.categories_list = result.data;
        },
        async createCategory() {
            const res = await axios.post(this.$store.getters.get_api_url + 'academy/categories', {
                name: this.newCategoryLabel,
            });

            if (res.status == 201) {
                this.showCategoryCreation = false;
                this.newCategoryLabel = "";
                this.loadCategories();
            } else {
                this.$store.commit('updateErrorMsg', 'Erreur lors de la création de la catégorie')
            }

        },
    },
    mounted() {
        this.loadCategories();
    }
}
</script>

<style scoped>
.administration-page {
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
}

.menu {
    margin: 0;
    padding: 10px;
    width: 320px;
}

.menu .router-link-active {
    color: #FB984B;
}

.menu h1:first-child {
    border-radius: 10px 10px 0 0;
}

.menu h1:last-child {
    border-radius: 0 0 10px 10px;
}

.menu h1 {
    background-color: #0A1C6B;
    color: white;
    padding: 10px;
    margin: 0;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
}

.menu h1 a {
    color: white;
    text-decoration: none;
}

.menu h1 .material-symbols-outlined {
    font-size: 26px;
}

.menu h1 .material-symbols-outlined:hover {
    cursor: pointer;
    color: #FB984B;
}

.menu ul {
    margin: 0;
    list-style-type: none;
    padding-left: 0;
}

.menu ul li {
    padding: 5px;
    background-color: white;
}

.menu ul li a {
    color: #1C1C1E;
    text-decoration: none;
    font-size: 18px;
}

.menu ul li a:hover {
    color: #FB984B;
}

.btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
}

.save-btn {
    cursor: pointer;
    padding: 15px;
    background-color: #FB984B;
    color: white;
    font-weight: bold;
    border-radius: 10px;
}

.content-wrapper {
    flex: 1;
    min-height: 100vh;
    /* pour voir la hauteur sur toute la page */
}
</style>